module.exports = __webpack_public_path__ + "static/iconjar2-8-1-210fdceab72f6f66edacf653b42e57f6.mp4";